import { render } from "./ContactPreferences.vue?vue&type=template&id=23a86e30"
import script from "./ContactPreferences.vue?vue&type=script&lang=js"
export * from "./ContactPreferences.vue?vue&type=script&lang=js"

import "./ContactPreferences.vue?vue&type=style&index=0&id=23a86e30&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__